import React, { useState } from "react";
import Background from "./layout/Background";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ProtectedRoute from "./components/ProtectedRoute";

/* ===== KIOSK / SYSTEM COMPONENTS ===== */
import KioskLock from "./components/kioskComponents/KioskLock";
import AndroidBackLock from "./components/kioskComponents/AndroidBackLock";
import EnterKiosk from "./components/kioskComponents/EnterKiosk";

import Layout from "./components/Layout";
import FloatingEtuButton from "./components/FloatingEtuButton";

/* ===== PAGES ===== */
import Dashboard from "./pages/Dashboard";
import NewProject from "./pages/NewProject";
import Login from "./pages/Login";
import Projects from "./pages/ProjectList";
import ConferenceRoom from "./pages/ConferenceRoom";
import CustomerFeedback from "./pages/CustomerFeedback";
import FinanceProjects from "./pages/FinanceProjects";
import FinanceProjectDetails from "./pages/FinanceProjectDetails";
import Whatsapp from "./pages/Whatsapp";

export default function App() {
  const [kioskStarted, setKioskStarted] = useState(false);

  // First screen → user taps to enter fullscreen (browser restriction)
  if (!kioskStarted) {
    return <EnterKiosk onEnter={() => setKioskStarted(true)} />;
  }

  return (
    <>
      {/* Animated background */}
      <Background />
      <div
        style={{
          position: "relative",
          zIndex: 1,
          minHeight: "100vh",
        }}
      >
        <BrowserRouter>
          {/* Web-level kiosk protections */}
          <KioskLock />
          <AndroidBackLock />

          {/* Top AppBar + App Launcher */}
          <Layout />

          {/* Application Routes */}
          <Routes>
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/newproject"
              element={
                <ProtectedRoute>
                  <NewProject />
                </ProtectedRoute>
              }
            />
            <Route path="/login" element={<Login />} />
            <Route
              path="/projects"
              element={
                <ProtectedRoute>
                  <Projects />
                </ProtectedRoute>
              }
            />
            <Route
              path="/conference-room"
              element={
                <ProtectedRoute>
                  <ConferenceRoom />
                </ProtectedRoute>
              }
            />
            <Route
              path="/feedback"
              element={
                <ProtectedRoute>
                  <CustomerFeedback />
                </ProtectedRoute>
              }
            />
            <Route
              path="/finance/get-projects"
              element={
                <ProtectedRoute>
                  <FinanceProjects />
                </ProtectedRoute>
              }
            />
            <Route
              path="/finance/projects/:id"
              element={
                <ProtectedRoute>
                  <FinanceProjectDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/whatsapp"
              element={
                <ProtectedRoute>
                  <Whatsapp />
                </ProtectedRoute>
              }
            />
          </Routes>
          <FloatingEtuButton />
        </BrowserRouter>
      </div>
    </>
  );
}
